import { Component, inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonService } from '../../../../../../../../shared/services/common.service';
import { RiskRegisterService } from '../risk-register.service';
import { RiskConfig } from '../risk-register.models';
import { serverErrorMessage } from '../risk-register.util';

/** Per-project risk areas and disciplines (spec §3.6). Removable chips + an add field each. */
@Component({
  selector: 'app-risk-config-dialog',
  templateUrl: './risk-config-dialog.component.html',
  styleUrls: ['./risk-config-dialog.component.scss'],
  standalone: false,
})
export class RiskConfigDialogComponent {
  areas: string[];
  disciplines: string[];
  newArea = new FormControl('');
  newDiscipline = new FormControl('');
  saving = false;

  readonly dialogRef = inject<MatDialogRef<RiskConfigDialogComponent>>(MatDialogRef);
  readonly data = inject<{ projectId: string; config: RiskConfig }>(MAT_DIALOG_DATA);
  private readonly riskService = inject(RiskRegisterService);
  private readonly commonService = inject(CommonService);

  constructor() {
    this.areas = [...(this.data.config?.risk_areas || [])];
    this.disciplines = [...(this.data.config?.disciplines || [])];
  }

  add(list: 'areas' | 'disciplines', control: FormControl): void {
    const v = String(control.value || '').replace(/\s+/g, ' ').trim();
    if (!v) return;
    if (!this[list].some(x => x.toLowerCase() === v.toLowerCase())) this[list] = [...this[list], v];
    control.setValue('');
  }
  remove(list: 'areas' | 'disciplines', v: string): void { this[list] = this[list].filter(x => x !== v); }

  save(): void {
    if (this.saving) return;
    this.saving = true;
    this.riskService.saveConfig(this.data.projectId, { risk_areas: this.areas, disciplines: this.disciplines }).subscribe({
      next: cfg => { this.saving = false; this.commonService.notification('Lists saved', 'success'); this.dialogRef.close(cfg); },
      error: err => { this.saving = false; this.commonService.notification(serverErrorMessage(err?.error, 'Could not save the lists'), 'error'); },
    });
  }
}
